import React from 'react'

const ErrorMessage = ({ fieldInfo, formikProps }) => {
    return (
        <>
            {formikProps.touched[fieldInfo.name] &&
            formikProps.errors[fieldInfo.name] && <div style={{
                color: 'red',
                fontSize: 16,
            }}>{typeof formikProps.errors[fieldInfo.name] === 'object' ? Object.values(formikProps.errors[fieldInfo.name]).join(', ') : formikProps.errors[fieldInfo.name]}
            </div>}
        </>

    )
}

export default ErrorMessage
